import React from "react";
import { Package } from "lucide-react";

const MyShakeBalance = () => {
    return (
        <div className="min-h-screen bg-slate-50 pb-24">
            <div className="px-6 py-12">
                <div className="bg-white rounded-2xl p-12 border border-slate-100 text-center max-w-md mx-auto">
                    <div className="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <Package className="w-8 h-8 text-slate-400" />
                    </div>
                    <h1 className="text-2xl font-bold text-slate-900 mb-2">Feature Removed</h1>
                    <p className="text-slate-600">
                        Shake balance tracking has been removed from the system.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MyShakeBalance;
